import {Component, Input, OnInit} from '@angular/core';
import {FormArray, FormControl} from '@angular/forms';
import {Asset} from '@app/@core/@models/advertising/asset.model';
import {Creative} from '@app/@core/@models/advertising/creative.model';
import {Layout} from '@app/@core/@models/advertising/layout/layout.model';
import {AssetComponentForm} from '@app/@core/advertising/campaign/layout/asset-comoponent-form';
import {LayoutComponentForm} from '@app/@core/advertising/campaign/layout/layout-component-form';
import {UrlComponentForm} from '@app/@core/advertising/campaign/layout/url-compnent-form';
import {TextComponentForm} from '@app/@core/advertising/campaign/layout/text-component-form';
import {ChoiceComponentForm,} from '@app/@core/advertising/campaign/layout/choice-comoponent-form';
import {ValidationWarningMessage} from '@app/@core/@models/advertising/validation-warning-message.model';
import {AdvertDraft} from '@app/@core/advertising/campaign/advert/advert-draft';
import {ConfigService} from '@app/@core/@config/config.service';
import { Product } from '@app/@core/@models/design/product.model';
import {TargetingFilterGroupForUi} from "@app/@core/@models/network/network-data.model";
import {Uuid} from "@shared/utils/uuid";
import {
  ProductData
} from '@app/campaigns/campaign/@common/campaign-drafting/product-selection/product-data-helper.service';

@Component({
  selector: 'app-creative-editor[advertDraft][showLoadingOverlays]',
  templateUrl: './creative-editor.component.html',
  styleUrls: ['./creative-editor.component.scss'],
})
export class CreativeEditorComponent implements OnInit {
  @Input() advertDraft!: AdvertDraft;
  @Input() showLoadingOverlays!: boolean;
  @Input() productData!: ProductData;
  targetingFilterGroupForUi: TargetingFilterGroupForUi[] = [];
  product: Product | undefined;
  layouts: Layout[] | undefined;
  layoutId: string | undefined;
  selectedLayout: Layout | undefined;
  assetControls: FormArray<FormControl<Asset>> | undefined;
  creativeId: string = "";
  hasCreativeCopyrightStatus:boolean = false;
  eitherSelection = false;
  uuid = Uuid.generate();

  constructor(private configService: ConfigService) {
  }

  ngOnInit(): void {
    this.product = this.advertDraft.campaignDraft.getProduct();
    this.targetingFilterGroupForUi = this.advertDraft.campaignDraft.targetingFilterGroupForUi.filter(tgui => {
      return tgui.productIds.find((p) => {
        return this.product && p === this.product.id;
      }) && tgui.targetingFilterOptions.length > 0;
    });
    this.layouts = this.advertDraft.campaignDraft.layoutsForSelectedProduct(this.product);
    this.layoutId = this.advertDraft.advertForm.value.layoutId;
    this.selectedLayout = this.layouts.find(layout => layout.id === this.layoutId)!;

    this.advertDraft.creative.dimensionType = this.selectedLayout && this.selectedLayout.layoutType === 'NATIVE' ? 'FLEXIBLE' : 'FIXED';
    if (this.advertDraft.creative.dimensionType === 'FLEXIBLE') {
      this.advertDraft.creative.width = 0;
      this.advertDraft.creative.height = 0;
    }

    this.assetControls = this.advertDraft.advertForm.controls.assets;
    this.creativeId = this.advertDraft.advertForm.controls.creativeId.value;
    this.hasCreativeCopyrightStatus = this.configService.getNetworkData()!.hasCreativeCopyrightStatus || false;
    this.eitherSelection = this.targetingFilterGroupForUi.length > 0 && (this.product?.creativeTargeting?.siteGroupTarget?.siteGroups?.length || 0) > 0;
  }

  get assets(): FormArray<FormControl<Asset>> {
    return this.advertDraft.advertForm.get('assets') as FormArray<FormControl<Asset>>;
  }

  getAssetArray(): Asset[] {
    const result: Asset[] = [];
    const assets = this.assets;
    for (let i = 0; i < assets.length; i++) {
      result.push(assets.at(i).getRawValue());
    }
    return result;
  }

  getCreativeFromForm(): Creative {
    return this.advertDraft.campaignDraft.creativeFromCreativeForm(
      this.advertDraft.campaignDraft.getProduct()!,
      this.advertDraft.advertForm,
      0
    );
  }

  toAssetComponentForm(layoutComponentForm: LayoutComponentForm): AssetComponentForm | undefined {
    if (this.advertDraft.campaignDraft.isAssetComponentForm(layoutComponentForm)) {
      return layoutComponentForm;
    } else {
      return undefined;
    }
  }

  toUrlComponentForm(layoutComponentForm: LayoutComponentForm): UrlComponentForm | undefined {
    if (this.advertDraft.campaignDraft.isUrlComponentForm(layoutComponentForm)) {
      return layoutComponentForm;
    } else {
      return undefined;
    }
  }

  toTextComponentForm(layoutComponentForm: LayoutComponentForm): TextComponentForm | undefined {
    if (this.advertDraft.campaignDraft.isTextComponentForm(layoutComponentForm)) {
      return layoutComponentForm;
    } else {
      return undefined;
    }
  }

  toChoiceComponentForm(layoutComponentForm: LayoutComponentForm): ChoiceComponentForm | undefined {
    if (this.advertDraft.campaignDraft.isChoiceComponentForm(layoutComponentForm)) {
      return layoutComponentForm;
    } else {
      return undefined;
    }
  }

  serverValidationWarnings(layoutComponentForm: LayoutComponentForm): ValidationWarningMessage[] | undefined {
    return this.advertDraft.advertForm.value.creative?.validationWarnings?.filter((validationWarningMessage) => {
      return validationWarningMessage.parameters?.componentTag === layoutComponentForm.value.layoutComponent?.tag;
    })
  }
}
